import { useMemo } from 'react';
import { ReportBackendTypes } from '@ais-ui/websockets';

/**
 * Custom hook to determine if a report type supports row selection
 * Centralizes the logic for which report types are selectable
 */
export const useSelectableReportType = (reportType: string | null) => {
  const selectableReportTypes = useMemo(
    (): string[] => [
      ReportBackendTypes.TRACK,
      ReportBackendTypes.TRIPS,
      ReportBackendTypes.FISHING,
      ReportBackendTypes.MULTI_SHAPE,
      ReportBackendTypes.NEAR_MISS_SHIP_TO_POINT,
      ReportBackendTypes.MMSI_CHANGE,
      ReportBackendTypes.NEAR_MISS_SHIP_TO_SHIP,
      ReportBackendTypes.PASSAGELINE,
      ReportBackendTypes.SOG_DISTRIBUTION,
      ReportBackendTypes.PILOT_OPERATIONS,
      ReportBackendTypes.TRANSIT_PILOTAGE,
    ],
    [],
  );

  const isSelectableReportType = useMemo(() => {
    if (!reportType) return false;
    return selectableReportTypes.includes(reportType);
  }, [reportType, selectableReportTypes]);

  /**
   * Check if a specific report type is selectable
   */
  const isReportTypeSelectable = useMemo(() => {
    return (type: string): boolean => {
      return selectableReportTypes.includes(type);
    };
  }, [selectableReportTypes]);

  /**
   * Get all selectable report types
   */
  const getAllSelectableTypes = useMemo(() => {
    return selectableReportTypes;
  }, [selectableReportTypes]);

  return {
    isSelectableReportType,
    isReportTypeSelectable,
    getAllSelectableTypes,
    selectableReportTypes,
  };
};
